const nl = {
  common: {
    save: 'Opslaan',
    cancel: 'Annuleren',
    delete: 'Verwijderen',
    edit: 'Bewerken',
    close: 'Sluiten',
    update: 'Bijwerken',
    updating: 'Bijwerken...',
    saving: 'Opslaan...',
    loading: 'Laden...',
    search: 'Zoeken:',
    all: 'Alles',
    actions: 'Acties',
    notes: 'Notitie',
    date: 'Datum',
    time: 'Tijd',
    status: 'Status',
    total: 'Totaal',
    today: 'Vandaag',
    tomorrow: 'Morgen',
    thisWeek: 'Deze Week',
    thisMonth: 'Deze Maand',
    thisYear: 'Dit Jaar',
    logout: 'Uitloggen',
    login: 'Inloggen',
    email: 'E-mailadres',
    password: 'Wachtwoord',
    developedBy: 'Ontwikkeld door',
    allRightsReserved: 'Alle rechten voorbehouden.',
    required: 'Verplicht',
    optional: 'Optioneel',
    filter: 'Filteren',
    clear: 'Wissen',
    details: 'Details',
    print: 'Printen',
    downloadPdf: 'Download PDF',
    whatsapp: 'WhatsApp',
    call: 'Bellen',
    yes: 'Ja',
    no: 'Nee',
    back: 'Terug',
    next: 'Volgende',
    success: 'Succesvol',
    error: 'Fout',
    warning: 'Waarschuwing',
    info: 'Informatie',
    confirm: 'Bevestigen',
    backToHome: 'Terug naar Home',
    ok: 'OK',
    add: 'Toevoegen',
    saveSettings: 'Instellingen Opslaan'
  },

  nav: {
    title: 'Ebrar Gordijnen - Klantenbeheer',
    home: 'Home',
    planning: 'Planning',
    customers: 'Klantenlijst',
    installationList: 'Montagelijst',
    users: 'Gebruikers',
    products: 'Productenlijst',
    accounting: 'Boekhouding'
  },

  header: {
    title: 'Ebrar Gordijnen - Klantenlijst',
    checkPermissions: 'Machtigingen controleren...',
    selectLanguage: 'Taal selecteren'
  },

  customer: {
    add: '+ Nieuwe Klant',
    customerInfo: 'Klantgegevens',
    name: 'Naam',
    phone1: 'Telefoon 1',
    phone2: 'Telefoon 2',
    address: 'Adres',
    city: 'Stad',
    cityOptional: 'Stad (Optioneel)',
    cityPlaceholder: 'Bijv: Utrecht, Den Haag...',
    postalCode: 'Postcode',
    postalCodeOptional: 'Postcode (Optioneel)',
    postalCodePlaceholder: 'Bijv: 3512 JE',
    notes: 'Notities',
    inspectionDate: 'Inmeetdatum & Tijd',
    inspectionCompleted: 'Inmeting Voltooid',
    inspectionUndo: 'Herstellen',
    inspectionToggleHint: 'Indien aangevinkt, wordt de inmeting verwijderd uit de actieve herinneringenlijst',
    orderDate: 'Besteldatum',
    deliveryDate: 'Montagedatum & Tijd',
    orderStatus: 'Bestelstatus',
    paidAmount: 'Ontvangen Betaling',
    remainingAmount: 'Openstaand Bedrag',
    paymentCompleted: 'Betaling Voldaan',
    paymentType: 'Betaalmethode',
    orders: 'Bestellingen',
    addOrder: '+ Bestelling Toevoegen',
    deleteConfirm: 'Weet u zeker dat u deze klant wilt verwijderen? Deze actie kan niet ongedaan worden gemaakt!',
    totalOrders: 'Totaal Bestellingen',
    totalPrice: 'Totaalbedrag',
    searchPlaceholder: 'Klantnaam, telefoonnummer of adres...',
    itemsPerPage: 'Per pagina:',
    tableView: 'Tabelweergave',
    cardView: 'Kaartweergave',
    noCustomersFound: 'Geen klanten gevonden.',
    stepCustomer: '1. Klantgegevens',
    stepOrder: '2. Besteldetails',
    goToOrderStep: 'Doorgaan naar Bestelling',
    saveOnlyCustomer: 'Alleen Klant Opslaan'
  },

  orderStatus: {
    new_order: 'Nieuwe Bestelling',
    firma: 'Leverancier',
    atolye: 'Atelier',
    montaj: 'Montage',
    delivered: 'Geleverd'
  },

  paymentType: {
    cash: 'Contant',
    iban: 'IBAN Bankoverschrijving',
    bank_card: 'Pinpas',
    credit_card: 'Creditcard'
  },

  productTypes: {
    tul: 'Vitrage',
    kanat: 'Overgordijn',
    stor: 'Rolgordijn',
    zebra: 'Duo Rolgordijn',
    ahsapJaluzi: 'Houten Jaloezie',
    metalJaluzi: 'Aluminium Jaloezie',
    dikeyPerde: 'Lamellen',
    dikeyPvc: 'PVC Lamellen',
    dikeyStor: 'Verticale Rolgordijnen',
    plise: 'Plissé',
    katlamaliPerde: 'Vouwgordijn',
    raySistemi: 'Railsystemen',
    rustik: 'Roedes',
    aksesuar: 'Accessoires'
  },

  productForm: {
    roomName: 'Kamer / Ruimte',
    roomPlaceholder: 'Bijv: Woonkamer, Slaapkamer',
    productType: 'Producttype',
    productName: 'Productnaam',
    productVariant: 'Variant',
    width: 'Breedte (cm)',
    height: 'Hoogte (cm)',
    unitPrice: 'Eenheidsprijs (€)',
    quantity: 'Aantal',
    pileModel: 'Plooi Model',
    pileDensity: 'Plooidichtheid',
    twoPiecesCenter: 'In twee gelijke delen sluiten',
    twoPiecesAlert: 'Atelier instructie: Wordt in 2 delen geleverd (+50 cm extra stof toegevoegd)',
    bottomHem: 'Onderzoom vouwen',
    usedM2: 'Gebruikte m²',
    usedMeter: 'Gebruikte meters',
    totalPrice: 'Totaalprijs (€)',
    discount: 'Korting (%)',
    discountedPrice: 'Prijs na korting (€)',
    direction: 'Bedieningszijde',
    directionLeft: 'Links',
    directionRight: 'Rechts',
    directionCenter: 'Midden opening',
    mounting: 'Montage',
    mountingIncluded: 'Inclusief montage',
    saveProduct: 'Product Opslaan',
    addProduct: '+ Product Toevoegen',
    accessories: 'Accessoires',
    notes: 'Product Notities',
    deleteProductConfirm: 'Weet u zeker dat u dit product wilt verwijderen?'
  },

  orderSummary: {
    subtotal: 'Subtotaal',
    discountedSubtotal: 'Totaal na productkorting',
    generalDiscount: 'Algemene Korting (%)',
    discountedTotal: 'Totaal na korting',
    grandTotal: 'Eindtotaal (Netto)',
    paymentCompleted: 'Betaling Voldaan',
    totalPaid: 'Totaal Betaald',
    remainingPayment: 'Openstaand Bedrag',
    paymentReceived: 'Betaling Ontvangen',
    paymentType: 'Betaalmethode:',
    paymentDate: 'Betaaldatum:',
    completePayment: 'Betaling Voltooien',
    cancel: 'Annuleren',
    newPayment: 'Nieuwe Betaling Toevoegen',
    amount: 'Bedrag (€):',
    add: 'Toevoegen',
    paymentHistory: 'Betalingsgeschiedenis',
    cancelPayment: 'Annuleren',
    savePricing: 'Prijsinformatie Opslaan',
    saving: 'Bezig met opslaan...'
  },

  dashboard: {
    customerStats: 'Klantstatistieken',
    revenueStats: 'Omzet & Financiële Samenvatting',
    totalCustomers: 'Totaal Klanten',
    activeCustomers: 'Actieve Klanten',
    expectedRevenue: 'Verwachte Omzet',
    totalRevenue: 'Totale Omzet',
    remainingBalance: 'Openstaande Vorderingen',
    collectedRevenue: 'Geïnde Omzet',
    remainingRevenue: 'Kalan Alacaklar',
    today: 'Vandaag',
    thisWeek: 'Deze Week',
    thisMonth: 'Deze Maand',
    thisYear: 'Dit Jaar',
    monthlyCustomerTrend: 'Maandelijkse Klantentrend',
    monthlyOrderTrend: 'Maandelijkse Bestellingentrend',
    monthlyEarningsTrend: 'Maandelijkse Omzettrend',
    customer: 'Klant',
    order: 'Bestelling',
    earnings: 'Omzet',
    lastYearComparison: 'Vergelijking Vorig Jaar',
    lastYearToday: 'Vorig Jaar Vandaag',
    lastYearThisWeek: 'Vorig Jaar Deze Week',
    lastYearThisMonth: 'Vorig Jaar Deze Maand',
    lastYearTotal: 'Vorig Jaar Totaal',
    sameDayCustomers: 'Aantal klanten op dezelfde dag',
    sameWeekCustomers: 'Aantal klanten in dezelfde week',
    sameMonthCustomers: 'Aantal klanten in dezelfde maand',
    yearTotalCustomers: 'Totaal over het gehele jaar',
    paymentBreakdown: 'Naar Betaalmethode',
    todayCash: 'Vandaag (Contant)',
    todayIban: 'Vandaag (IBAN)',
    todayCard: 'Vandaag (Pinpas)',
    cashDesc: 'Contante betalingen',
    ibanDesc: 'Bankoverschrijvingen',
    cardDesc: 'Pin / kaartbetalingen',
    dataManagement: 'Gegevensbeheer',
    backupExport: 'Back-up Maken',
    backupExportDesc: 'Exporteer al uw klant- en bestelgegevens in JSON-formaat',
    exporting: 'Bezig met exporteren...',
    backupImport: 'Back-up Importeren',
    backupImportDesc: 'Herstel een eerder opgeslagen back-upbestand',
    backupNotice: 'Belangrijk: Het importeren verwijdert geen bestaande gegevens. Gegevens met hetzelfde ID worden bijgewerkt, nieuwe gegevens worden toegevoegd.',
    companyInfo: 'Bedrijfsinformatie',
    show: 'Tonen',
    hide: 'Verbergen',
    companyName: 'Bedrijfsnaam *',
    companyNamePlaceholder: 'Voer bedrijfsnaam in',
    companyPhone: 'Telefoonnummer *',
    companyPhoneHint: 'Inclusief landcode (bijv. 31612345678 of 905321234567)',
    registeredCompanies: 'Geregistreerde Bedrijven',
    noCompanies: 'Nog geen bedrijven toegevoegd.',
    companyInfoNotice: 'Informatie: De toegevoegde bedrijven zijn zichtbaar bij het verzenden van WhatsApp-berichten.',
    changePassword: 'Wachtwoord Wijzigen',
    currentPassword: 'Huidig Wachtwoord *',
    currentPasswordPlaceholder: 'Voer uw huidige wachtwoord in',
    newPassword: 'Nieuw Wachtwoord *',
    newPasswordPlaceholder: 'Voer nieuw wachtwoord in (min. 6 tekens)',
    newPasswordHint: 'Moet minimaal 6 tekens bevatten',
    confirmPassword: 'Nieuw Wachtwoord Bevestigen *',
    confirmPasswordPlaceholder: 'Herhaal uw nieuwe wachtwoord',
    changingPassword: 'Bezig met wijzigen...',
    cacheRefresh: 'Gegevens Vernieuwen',
    cacheLastUpdated: 'Laatst Bijgewerkt:'
  },

  planning: {
    title: 'Afspraak-, Inmeet- & Routeplanning Centrum',
    subtitle: 'Groepeer inmeet- en montage-afspraken op regio en optimaliseer met Google Maps routes.',
    regionalPlanner: 'Regio & Routeplanner',
    timeline: 'Agenda (Tijdlijn)',
    montajTab: 'Montage / Levering',
    kesifTab: 'Inmeten / Afspraak',
    mapPinsTab: 'Kaart & Locaties',
    routeFromLocation: 'Route vanaf locatie',
    routeFromStore: 'Vanaf winkel',
    listStops: 'Haltes Weergeven',
    closeStops: 'Haltes Sluiten',
    goToStop: 'Navigeer vanaf locatie',
    allPins: 'Alles op kaart openen',
    pinKesif: 'Inmetingen Pinnen',
    pinMontaj: 'Montages Pinnen',
    sameDayOpportunity: 'Zelfde dag kans!',
    overdue: 'Vertraagde Afspraken',
    today: 'Vandaag',
    tomorrow: 'Morgen',
    thisWeek: 'Deze Week',
    upcoming: 'Aankomende Afspraken',
    completedInspections: 'Voltooide Inmetingen',
    showCompleted: 'Toon Voltooide',
    noAppointments: 'Geen geplande afspraken gevonden voor dit filter.',
    searchPlaceholder: 'Zoek regio, stad of klant...',
    filterAll: 'Alle Afspraken',
    filterToday: 'Alleen Vandaag',
    filterWeek: 'Deze Week (7 dagen)',
    filterOverdue: 'Vertraagd',
    stopsSequence: 'Volgorde van Haltes',
    stopsHint: 'Klik op "Navigeer vanaf locatie" bij de klant om direct live navigatie vanaf uw huidige GPS-locatie te starten.',
    directions: 'Routebeschrijving'
  },

  userManagement: {
    title: 'Gebruikersbeheer',
    subtitle: 'Beheer systeemgebruikers, rollen en toegangsrechten.',
    addUser: '+ Nieuwe Gebruiker Toevoegen',
    name: 'Naam',
    email: 'E-mailadres',
    role: 'Rol',
    roles: {
      admin: 'Beheerder (Admin)',
      satisci: 'Verkoper',
      montajci: 'Monteur',
      yazilimci: 'Ontwikkelaar'
    },
    rolePermissions: 'Rolbevoegdheden',
    roleDescriptions: {
      admin: 'Volledige toegang tot het hele systeem. Bevoegdheid om gebruikers aan te maken en te verwijderen.',
      satisci: 'Klanten en bestellingen toevoegen, bewerken en verwijderen. Geen toegang tot het dashboard.',
      montajci: 'Alleen bestellingen met montagestatus inzien en markeren als afgeleverd.',
      yazilimci: 'Toegang tot alle functies, maar kan alleen zelf aangemaakte gegevens inzien.'
    },
    permissions: 'Machtigingen',
    actions: 'Acties'
  },

  login: {
    title: 'Ebrar Gordijnen',
    subtitle: 'Klant- en Bestelbeheer',
    emailLabel: 'E-mailadres',
    emailPlaceholder: 'voorbeeld@ebrargordijnen.nl',
    passwordLabel: 'Wachtwoord',
    passwordPlaceholder: '••••••••',
    submitBtn: 'Inloggen',
    loggingIn: 'Inloggen...',
    languageLabel: 'Taal / Dil:'
  },

  pileModels: {
    sPile: 'Wave Plooi (S-Plooi)',
    americanTekli: 'Enkele Plooi (Amerikaans)',
    american2: 'Dubbele Plooi (Vlinderplooi)',
    american3: 'Driedubbele Plooi',
    kapsul: 'Ringen / Zeilogen',
    altEtekKatlama: 'Onderzoom Dubbel'
  },

  productList: {
    title: 'Productenlijst',
    subtitle: 'Productcatalogus gecategoriseerd op producttype',
    loading: 'Laden...',
    empty: 'Er zijn nog geen producten in deze categorie.',
    addFirstProduct: 'Voeg eerste product toe',
    searchPlaceholder: 'Zoek op productnaam...',
    clearSearch: 'Zoekopdracht wissen',
    resultsCount: 'resultaten',
    addNewProduct: 'Nieuw Product Toevoegen',
    table: {
      rowNum: '#',
      productName: 'Productnaam',
      unitPrice: 'Eenheidsprijs',
      unitPriceShort: 'Verkoop',
      merdivenIpli: 'Laddertouw (Prijs)',
      kurdeleli: 'Band (Prijs)',
      merdivenIpliReduktorlu: 'Laddertouw Vert. (Prijs)',
      kurdelaliReduktorlu: 'Band Vert. (Prijs)',
      rusticProduct: 'Roede Product',
      actions: 'Acties'
    },
    excel: {
      productUnit: 'producten',
      import: 'Excel Importeren',
      export: 'Excel Exporteren',
      clearList: 'Lijst Wissen',
      clearConfirmTitle: 'Lijst Wissen',
      clearConfirmMessage: 'LET OP! ALLE {count} producten in de categorie "{type}" worden definitief verwijderd.\n\nDeze actie kan niet ongedaan worden gemaakt. Weet u het zeker?',
      noProductsToExport: 'Geen producten gevonden om te exporteren.',
      noProductsToDelete: 'Geen producten gevonden om te verwijderen in deze categorie.',
      deletedTitle: 'Gewist',
      deletedCount: '{count} producten zijn succesvol verwijderd.',
      clearError: 'Fout bij het wissen van de lijst: ',
      emptyOrUnreadable: 'Excel-bestand is leeg of kan niet worden gelezen.',
      invalidFormatTitle: 'Ongeldig Formaat',
      invalidFormatMsg: 'Ongeldig Excel-formaat! Het bestand moet de kolommen "Ürün Adı" en "Birim Fiyat" bevatten.\n\n(Download eerst een voorbeeldbestand via "Excel Exporteren")',
      invalidFormatJaluziMsg: 'Ongeldig Excel-formaat! Houten/Aluminium Jaloezieën bestanden moeten kolommen zoals "Ürün Adı", "Merdiven İpli", "Kurdeleli" bevatten.\n\n(Download eerst een voorbeeldbestand via "Excel Exporteren")',
      importConfirmTitle: 'Excel Importeren Bevestiging',
      importConfirmMsg: '{count} producten uit het Excel-bestand worden verwerkt:\n\n• Overeenkomende producten uit de huidige {existing} producten worden bijgewerkt\n• Nieuwe producten die niet in de lijst staan worden toegevoegd\n• Producten die wel in de lijst staan maar niet in Excel blijven behouden\n\nGaat u akkoord?',
      updatedCount: '{count} producten bijgewerkt',
      addedCount: '{count} nieuwe producten toegevoegd',
      noChanges: 'Geen wijzigingen aangebracht.',
      parseErrorTitle: 'Parseerfout',
      parseErrorMsg: 'Er is een fout opgetreden bij het lezen van het bestand.',
      readError: 'Er is een fout opgetreden bij het lezen van het Excel-bestand: '
    },
    modal: {
      newProduct: 'Nieuw Product Toevoegen',
      editProduct: 'Product Bewerken',
      productType: 'Producttype',
      productName: 'Productnaam',
      productNamePlaceholder: 'bijv. Karya Gladde Vitrage',
      dynamicPricing: 'Dynamische Prijzen',
      merdivenIpliPrice: 'Laddertouw Verkoopprijs',
      kurdeleliPrice: 'Band Verkoopprijs',
      merdivenIpliReduktorluPrice: 'Laddertouw Vertraging Verkoopprijs',
      kurdelaliReduktorluPrice: 'Band Vertraging Verkoopprijs',
      rustikInfo: 'Prijzen voor roedeproducten worden tijdens de bestelling automatisch berekend op basis van dragers en accessoires. Hier hoeft alleen de productnaam te worden ingevoerd.',
      unitPriceLabel: 'Eenheidsprijs (Verkoop - €)',
      deleteTitle: 'Product Verwijderen',
      deleteConfirmQuestion: 'weet u zeker dat u dit product wilt verwijderen?',
      deleteWarning: 'Deze actie kan niet ongedaan worden gemaakt.',
      confirmationNeeded: 'Bevestiging Vereist',
      yesUpload: 'Ja, Importeren',
      productUpdated: 'Product succesvol bijgewerkt!',
      productAdded: 'Product succesvol toegevoegd!',
      productSaveError: 'Er is een fout opgetreden bij het opslaan van het product: ',
      productDeleteError: 'Fout bij verwijderen van product: ',
      settingsSaved: 'Instellingen succesvol opgeslagen.',
      settingsSaveError: 'Er is een fout opgetreden bij het opslaan van de instellingen.'
    },
    motorSettings: {
      title: 'Motor- en Afstandsbedieningsinstellingen',
      subtitle: 'Motor- en afstandsbedieningstarieven voor 3 verschillende motorleveranciers',
      titleWithType: 'Motor- en Afstandsbedieningsinstellingen ({type})',
      subtitleWithType: 'Motor- en afstandsbedieningstarieven van 3 leveranciers voor {type}-bestellingen',
      titleSuffix: 'Motor- en Afstandsbedieningsinstellingen',
      subtitleSuffix: 'motor- en afstandsbedieningstarieven voor 3 leveranciers gebruikt in bestellingen',
      jaluziMotorTitle: 'Jaloezie Motor- en Afstandsbedieningsinstellingen',
      jaluziMotorSubtitle: 'Motor- en afstandsbedieningstarieven voor 3 leveranciers gebruikt in jaloeziebestellingen',
      company: 'Leverancier',
      firm: 'Bedrijf {num}',
      motor: 'Motor',
      remote: 'Afstandsbediening',
      motorPrice: 'Motor (€)',
      kumandaPrice: 'Afstandsbediening (€)'
    },
    extraPrices: {
      pileExtraTitle: 'Plooi Extra Kosten Instellingen',
      tulTitle: 'Extra Plooikosten Vitrage',
      tulSubtitle: 'Extra plooikosten voor vitrage bestellingen',
      kanatTitle: 'Extra Plooikosten Overgordijn',
      kanatSubtitle: 'Extra plooikosten voor overgordijn bestellingen',

      storMotorTitle: 'Rolgordijn Motor- en Afstandsbedieningsinstellingen',
      storMotorSubtitle: 'Motor- en afstandsbedieningstarieven van 3 leveranciers voor rolgordijnbestellingen',
      zebraMotorTitle: 'Duo Rolgordijn Motor- en Afstandsbedieningsinstellingen',
      zebraMotorSubtitle: 'Motor- en afstandsbedieningstarieven van 3 leveranciers voor duo rolgordijnbestellingen',
      storTitle: 'Rolgordijn Prijsinstellingen',
      storSubtitle: 'Extra systeem- en accessoirekosten voor rolgordijn bestellingen',
      zebraTitle: 'Duo Rolgordijn Prijsinstellingen',
      zebraSubtitle: 'Extra systeem- en accessoirekosten voor duo rolgordijn bestellingen',

      ahsapMotorTitle: 'Houten Jaloezie Motor- en Afstandsbedieningsinstellingen',
      ahsapMotorSubtitle: 'Motor- en afstandsbedieningstarieven van 3 leveranciers voor houten jaloezieën',
      metalMotorTitle: 'Aluminium Jaloezie Motor- en Afstandsbedieningsinstellingen',
      metalMotorSubtitle: 'Motor- en afstandsbedieningstarieven van 3 leveranciers voor aluminium jaloezieën',
      ahsapTitle: 'Extra Kosten Houten Jaloezieën',
      metalTitle: 'Extra Kosten Aluminium Jaloezieën',
      jaluziSubtitle: 'Extra service- en systeemkosten',

      dikeyPerdeMotorTitle: 'Lamellen Motor- en Afstandsbedieningsinstellingen',
      dikeyPerdeMotorSubtitle: 'Motor- en afstandsbedieningstarieven van 3 leveranciers voor lamellen bestellingen',
      dikeyPvcMotorTitle: 'PVC Lamellen Motor- en Afstandsbedieningsinstellingen',
      dikeyPvcMotorSubtitle: 'Motor- en afstandsbedieningstarieven van 3 leveranciers voor PVC lamellen bestellingen',
      dikeyStorMotorTitle: 'Verticale Rolgordijnen Motor- en Afstandsbedieningsinstellingen',
      dikeyStorMotorSubtitle: 'Motor- en afstandsbedieningstarieven van 3 leveranciers voor verticale rolgordijnen',

      katlamaliMotorTitle: 'Vouwgordijn Motor- en Afstandsbedieningsinstellingen',
      katlamaliMotorSubtitle: 'Motor- en afstandsbedieningstarieven van 3 leveranciers voor vouwgordijnbestellingen',

      perdeExtraTitle: 'Gordijn Prijsinstellingen',
      jaluziExtraTitle: 'Extra Jaloeziekosten',
      jaluziExtraSubtitle: 'Extra service- en systeemkosten'
    },
    orderMotor: {
      title: 'Motor- & Afstandsbedieningsselectie',
      company: 'Motorleverancier',
      withoutMotor: 'Zonder Motor',
      package: 'Motor / Afstandsbediening Pakket',
      select: 'Selecteer',
      motorTotal: 'Motor Totaal (€)',
      motor: 'Motor',
      remote: 'Afstandsbediening',
      remoteIncluded: '✓ Afstandsbediening inbegrepen'
    },
    extraFields: {
      wooden: 'Hout',
      metal: 'Aluminium',
      jumbo: 'Jumbo Systeem',
      altEtekDilim: 'Schulp Onderlat',
      kapaliKasa: 'Gesloten Cassette',
      altEtekLazer: 'Laser Onderlat',
      dekoratifLama: 'Decoratieve Onderlat',
      dekoratifKasa: 'Decoratieve Cassette',
      altEtekBeyazIs: 'Witte Borduur Onderlat',
      zigil: 'Zijgeleiding',
      zigilPiece: 'Zijgeleiding (Stuk)',
      reduktorDiffM2: 'Vertraging Toeslag (m²)',
      ikiCamArasiPiece: 'Tussen Twee Glas (Stuk)'
    },
    dikeySettings: {
      fonTitle: 'Verticale Lamellen Zijbanen Instellingen',
      fonSubtitle: 'Zijbaan tarief en namenlijst',
      fonPriceM2: 'Verticale Lamellen Zijbaan Tarief (m²)',
      fonNamesList: 'Zijbaan Namenlijst',
      newFonPlaceholder: 'Nieuwe Zijbaannaam (Bijv: Zijbaan 1)',
      emptyList: 'Lijst is leeg'
    },
    katlamaliSettings: {
      motorTitle: 'Vouwgordijn Motor- en Afstandsbedieningsinstellingen',
      motorSubtitle: 'Motor- en afstandsbedieningstarieven voor 3 motorleveranciers gebruikt in vouwgordijnbestellingen',
      title: 'Vouwgordijn Mechanisme Instellingen',
      subtitle: 'Mechanismetypes en tarieven',
      mechanismTypePlaceholder: 'Mechanisme Type (Bijv: 5+1)',
      pricePlaceholder: 'Tarief',
      registeredMechanisms: 'Geregistreerde Mechanismetypes',
      editingBadge: 'Bewerken',
      emptyTitle: 'Nog geen mechanismetype toegevoegd.',
      emptyDesc: 'Gebruik het bovenstaande formulier om het eerste mechanisme toe te voegen.'
    },
    rustikSettings: {
      title: 'Roede Drager Tariefinstellingen',
      defaultFootPrice: 'Standaard Dragertarief',
      defaultFootPriceDesc: 'Standaard eenheidsprijs voor dragers in roedebestellingen. Deze waarde wordt automatisch overgenomen in het bestelformulier.',
      footModelList: 'Drager Modellijst',
      footDiameterList: 'Drager Diameterlijst',
      footLengthList: 'Drager Lengtelijst',
      footColorCodeList: 'Drager Kleurcodelijst',
      newModelPlaceholder: 'Nieuw Model (Bijv: Model 1)',
      newDiameterPlaceholder: 'Nieuwe Diameter (Bijv: 28mm)',
      newLengthPlaceholder: 'Nieuwe Lengte (Bijv: 15cm)',
      newColorPlaceholder: 'Nieuwe Kleur (Bijv: Zwart / Mat)'
    }
  }
};

export default nl;
